// extracted by css-extract-rspack-plugin
export default {"recipientsContainer":"_feff01bb","avatarsContainer":"_8bc45ab1","avatarWrapper":"_f3da076","onBanner":"_f46d0101","recipientsCount":"_62e00eff"};